<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="deleteSatelite"
    >
      <header class="m-the-modal-header">
        <h5>{{ $t('mEditionBillingSatellites.modalDelete.title') }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>

      <section
        key="modalSection"
        class="m-the-modal-section"
      >
        <p>
          {{ $t('mEditionBillingSatellites.modalDelete.text') }}
          <b>{{ satelite.titulo }}</b>.
        </p>
        <small class="text-color-danger">
          {{ $t('mEditionBillingSatellites.modalDelete.warning') }}
        </small>
      </section>

      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction
          :cancel-text="$t('mEditionBillingSatellites.modalDelete.buttons.cancel')"
        />
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
import { sufijoDe } from '@/plugins/satelites/droops'

export default {
  name: 'MoleculeEditionBillingSatellitesModalDelete',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mEditionBillingSatellites.modalDelete.buttons.submit'),
        class: 'a-button-danger-primary',
        sending: false,
        type: 'submit'
      },

      satelite: {},
      tab: 'juedroop'
    }
  },

  created () {
    this.satelite = this.$modal.element.satelite
    this.tab = this.$modal.element.tab
  },

  methods: {
    deleteSatelite () {
      if (this.buttonPrimary.sending) {
        return
      }

      this.buttonPrimary.sending = true

      const endpoint = `deleteSatelite${sufijoDe(this.tab)}`

      this.$services.delete('satelite', endpoint, {}, [this.satelite.id])
        .then(() => {
          this.$alerts.pushAlert('mEditionBillingSatellites', 'deleteSatelite', 'success', 'a-alert-success')
          this.$modal.updateData('readSatelites')
          this.$modal.closeModal()
        })
        .catch(() => {
          this.$alerts.pushAlert('mEditionBillingSatellites', 'deleteSatelite', 'error', 'a-alert-danger')
        })
        .finally(() => {
          this.buttonPrimary.sending = false
        })
    }
  }
}
</script>
